<template>
    <b-navbar type="is-dark" style="height:50px">

        <template slot="brand">
            <b-navbar-item v-if="backLinkIsAvailable" @click.prevent.stop="goBack">
                <span class="icon">
                    <i class="fa fa-chevron-left"></i>
                </span>
            </b-navbar-item>
            <b-navbar-item tag="span">
                <span v-if="portal" style="font-size:1.25rem">
                    <strong class="has-text-light">{{ portal.long_name }}</strong>
                </span>
                <span v-else style="font-size:1.25rem">STORM<strong class="has-text-light">PORT</strong></span>
            </b-navbar-item>
        </template>

        <template slot="start">
            <b-navbar-item v-for="link in links" tag="router-link" active-class="is-active" :to="link.url" :key="link.url">
                <span v-if="link.icon" class="icon">
                    <i :class="link.icon"></i>
                </span>
                {{ link.text }}
            </b-navbar-item>
            <b-navbar-item v-if="canViewFormio" tag="a" href="#" @click.prevent="openFormio">
                Forms
            </b-navbar-item>
            <b-navbar-item v-if="canInspectAssets" tag="a" href="#js-stormport-assets-link"
                @click.prevent="openStormportAssetsLink">
                Missions
            </b-navbar-item>
            <b-navbar-item v-if="canUseMobileApp" tag="router-link" :to="{ name: 'mobile' }">
                Mobile
            </b-navbar-item>
        </template>

        <template slot="end">

            <b-navbar-item>
                <b-dropdown aria-role="list" style="padding:10px; cursor:pointer;">
                    <span slot="trigger" slot-scope="{ active }">
                        {{ user.email }}
                        <i class="fa fa-chevron-down"></i>
                    </span>
                    <router-link tag="a" class="dropdown-item" aria-role="listiem" :to="{ name: 'profile' }">
                        Configuration
                    </router-link>
                    <b-dropdown-item v-if="isSuperAdmin" aria-role="listitem">
                        <a href="https://assets.stormport-beta.nz">Assets</a>
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem">
                        <a href="https://service.sitevitals.net">Support</a>
                    </b-dropdown-item>
                    <router-link v-if="canViewTests" tag="a" class="dropdown-item" aria-role="listiem"
                        :to="{ name: 'tests' }">
                        Tests
                    </router-link>
                    <b-dropdown-item aria-role="listitem" @click="logout">Logout</b-dropdown-item>
                </b-dropdown>
            </b-navbar-item>

            <b-navbar-item v-if="integrationSystemStatusAvailable">
                <integration-server-traffic-light v-slot="slotProps">
                    <span v-if="slotProps.light">
                        <b-tooltip v-if="slotProps.light == 'red'"
                            :type="slotProps.light == 'red' ? 'is-danger' : 'is-dark'" position="is-bottom"
                            :label="slotProps.info" multilined>
                            <span>
                                <!--
                                <b-tag v-if="slotProps.light == 'red'" type="is-danger" rounded><strong>{{ slotProps.count }}</strong></b-tag>
                                <b-tag v-else-if="slotProps.light == 'green'" type="is-success" rounded><strong>OK</strong></b-tag>
                                -->
                                <b-icon icon="alert-circle" type="is-danger"></b-icon>
                            </span>
                        </b-tooltip>
                        <b-icon v-else-if="slotProps.light == 'green'" icon="check-circle" size="is-small" type="is-success"
                            title="GOOD SERVICE"></b-icon>
                    </span>
                </integration-server-traffic-light>
            </b-navbar-item>
            <b-navbar-item>
                <i class="fa fa-wifi" aria-hidden="true" id="status"></i>
            </b-navbar-item>
            <b-navbar-item @click="showGuide">
                <b-icon icon="book"></b-icon>
            </b-navbar-item>
            <b-navbar-item tag="a" href="/pwa.html" target="_blank" v-if="canBeInstalled">
                <b-icon icon="download"></b-icon>
            </b-navbar-item>
        </template>

    </b-navbar>
</template>

<script>

import Permissions from "@/helpers/permissions";
import Roles from "@/helpers/roles";
import { configurationPermissions } from "@/mixins/configurationPermissions";
import IntegrationServerTrafficLight from "@/components/System/IntegrationServerTrafficLight.vue";
import { AssociatedService } from "@/services/associated.service";
import AuthUtil from '@/utils/auth.util';
import { PortalService } from "@/services/portal.service";
import { JsonDenormalizer } from '@/helpers/JsonDenormalizer.js'

export default {
    name: "app-header",
    components: {
        IntegrationServerTrafficLight,
    },
    mixins: [configurationPermissions],
    links: [
        {
            url: "/orders",
            text: "Orders",
            permissions: [Permissions.CAN_VIEW_ORDERS]
        },
        {
            url: "/operations",
            text: "Operations",
            permissions: [Permissions.CAN_MANAGE_OPERATIONS]
        },
        {
            url: "/invoices",
            text: "Invoices",
            permissions: [Permissions.CAN_VIEW_INVOICES]
        },
        {
            url: "/batches",
            text: "Batches",
            permissions: [Permissions.CAN_VIEW_BATCHES]
        },
        {
            url: "/forms",
            text: "Inspections",
            permissions: [Permissions.CAN_VIEW_INSPECTIONS]
        },
        // {
        //   url: "/formio",
        //   text: "Formio",
        //   permissions: ["can view formio"]
        // },
        {
            url: "/assets-offline",
            text: "Assets",
            permissions: [Permissions.CAN_VIEW_ASSETS]
        },
        {
            url: "/documents",
            text: "Documents",
            permissions: [Permissions.CAN_VIEW_DOCUMENTS]
        },
        // {
        //   url: "/organisations",
        //   text: "Organisations",
        //   permissions: [Permissions.CAN_MANAGE_FIRMS]
        // }
    ],
    data() {
        return {
            environment: "production",
            referrer: "",
            stormportAssetsUrl: "",
            stormportMobileAppUrl: "",
            menuIsOpen: false,
            hasAssociatedFirms: true,
            canBeInstalled: false,
            portal: null
        };
    },
    computed: {
        isAdmin() {
            return this.$store.getters["Auth/hasRole"](Roles.ADMIN);
        },
        isSuperAdmin() {
            return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);
        },
        canInspectAssets() {
            return this.$store.getters["Auth/hasPermission"]("can inspect assets");
        },
        canUseMobileApp() {
            return this.$store.getters["Auth/hasPermission"]("mobile application access");
        },
        canViewTests() {
            return this.$store.getters["Auth/hasPermission"]("can view tests");
        },
        canViewFormio() {
            return this.$store.getters["Auth/hasPermission"]("can view formio");
        },
        user() {
            return this.$store.state.Auth.user;
        },
        authToken() {
            return this.$store.state.Auth.token;
        },
        links() {
            let links = [];

            this.$options.links.forEach(link => {
                const roles = link.roles || [];
                const permissions = link.permissions || [];

                const roleChecked = roles.every(role =>
                    this.$store.getters["Auth/hasRole"](role)
                );

                const permissionChecked = permissions.every(permission =>
                    this.$store.getters["Auth/hasPermission"](permission)
                );

                if (roleChecked && permissionChecked) {
                    links.push(link);
                }
            });

            if (
                //this.hasAssociatedFirms &&
                (this.isAdmin || this.isSuperAdmin) &&
                this.$store.getters["Auth/hasPermission"]("can view firms")
            ) {
                links.push({
                    text: "Organisations",
                    url: "/organisations"
                });
            }

            if (this.$store.getters["Auth/hasPermission"]("can view scheduled orders")) {
                links.push({
                    text: "Schedular",
                    url: "/schedular"
                });
            }

            // if ((this.isAdmin || this.isSuperAdmin) && this.configurationStatus) {
            if (this.isSuperAdmin && this.configurationStatus) {
                links.push({
                    text: "System",
                    url: "/configuration"
                });
            }

            return links;
        },
        backLinkIsAvailable() {
            return this.$store.getters.insideMobileApp
                && this.$store.getters["Auth/hasPermission"]('can view legacy back link');
        },
        integrationSystemStatusAvailable() {
            return this.$store.getters["Auth/hasPermission"]('can view integration system status');
        }
    },
    mounted() {

        this.getPortal();

        this.$data.environment = process.env.ENVIRONMENT;
        this.stormportAssetsUrl = process.env.STORMPORT_ASSETS_URL;
        this.stormportMobileAppUrl = process.env.STORMPORT_MOBILE_APP_URL;

        if (
            document.referrer.indexOf(location.protocol + "//" + location.host) !== 0
        ) {
            this.$data.referrer = document.referrer;
        }
        var status = document.getElementById("status");
        function updateOnlineStatus(event) {
            var condition = navigator.onLine ? "fa fa-wifi online" : "fa fa-wifi offline";
            status.className = condition;
        }
        updateOnlineStatus();
        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        const userAgent = window.navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(userAgent) || /android/.test(userAgent)) {
            let displayMode = null;
            ["browser", "standalone", "minimal-ui", "fullscreen"].forEach((v) => {
                if (window.matchMedia("(display-mode: " + v + ")").matches) {
                    displayMode = v;
                }
            });
            if (displayMode != "standalone") {
                this.canBeInstalled = true;
            }
        }
    },
    watch: {
        user() {
            this.setHasAssociatedFirms();
        }
    },
    methods: {

        getPortal() {
            let host = window.location.host;
            PortalService.find({ column: 'subdomain', value: host }).then(response => {
                let portal = JsonDenormalizer.denormalize(response);
                if (portal) {
                    this.portal = portal;
                }
            });
        },
        async setHasAssociatedFirms() {
            try {
                const organisations = await AssociatedService.firmFirm({
                    parent_id: this.user.firmId,
                    archived: true
                }).then(response => response.data);
                this.hasAssociatedFirms = organisations.length > 0;
            } catch (err) { }
        },
        goBack() {
            // ------------------------------------------------------------------
            // NOTE: This code is far from perfect but is fine for first release
            // ------------------------------------------------------------------

            // If we're at a top-level page, go back to parent application
            if (this.$route.path.split("/").length <= 2) {
                const redirect = this.$store.state.initialReferrer || process.env.APP_WORK_ORDERS_URL;

                if (redirect) {
                    window.location.href = redirect;
                } else this.$router.push("/");
            } else {
                // Look at route meta for the recommended route to go back to
                // (otherwise, we use the router's default 'back' behaviour)
                const back =
                    this.$route.meta && this.$route.meta.back
                        ? this.$route.meta.back
                        : false;

                if (back) {
                    const { location, route, href } = this.$router.resolve(back);

                    if (route.matched.length) {
                        return this.$router.push(route.path);
                    }
                }

                this.$router.go(-1);
            }
        },
        logout() {
            // clear local storage
            localStorage.clear();
            this.$store.dispatch("Auth/clearToken");
            // this.$router.replace({ name: "login" });
        },
        showGuide() {
            this.$store.state.guideSidebar = true;
        },
        openStormportAssetsLink($event) {
            const url = `${this.stormportAssetsUrl}?token=${this.authToken}`
            window.open(url, '_blank');
        },
        openFormio() {
            // Reset filters before redirecting to /formio
            localStorage.removeItem("__formio_form_filters");
            window.location.replace("/formio");
        }

    }
}

</script>

<style scoped>
@media only screen and (min-width: 960px) {
    .navbar {
        padding: 0 1em;
    }
}

.dropdown-menu {
    padding-top: 0px !important;
    min-width: 187px !important;
}

.dropdown-content a {
    color: #545454;
}

.online {
    color: lime;
}

.offline {
    color: #ff3b3b;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Header-new.vue